import { SessionStorageKeys } from './keys';

/**
 * Clear all session storage data that relates to a specific user
 */
export const clearUserSessionStorage = () => {
  window.sessionStorage.removeItem(SessionStorageKeys.HOLIDAY_MSG_SHOW_COUNT);
};
